import { customScrollbar } from '../../utility/index.js';

customScrollbar(
  '.horizontal-posts',
  '.horizontal-posts__posts',
  '.horizontal-posts__scrollbar'
);
